import React, { useState, useContext } from 'react';
import { CategoryContext } from '../../providers/CategoryContext';
import { AuthContext } from '../../providers/AuthContext';
import { showError, showSuccess } from '../../utils/sweetAlert';
import { getAdminAuthHeaders } from '../../utils/adminApi';

const BulkDiscount = ({ onDiscountApplied = () => {} }) => {
  const { categories } = useContext(CategoryContext);
  const { token } = useContext(AuthContext);
  const [category, setCategory] = useState('');
  const [subcategory, setSubcategory] = useState('');
  const [discount, setDiscount] = useState(0);

  const handleBulkDiscount = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/products/bulk-discount`, {
        method: 'PUT',
        headers: getAdminAuthHeaders(token, { 'Content-Type': 'application/json' }),
        body: JSON.stringify({ discount, category, subcategory })
      });
      const data = await response.json();
      showSuccess(data.message);
      onDiscountApplied();
    } catch (error) {
      console.error(error);
      showError('Error aplicando descuento masivo');
    }
  };

  const handleRemoveDiscount = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/products/remove-discount`, {
        method: 'PUT',
        headers: getAdminAuthHeaders(token, { 'Content-Type': 'application/json' }),
        body: JSON.stringify({ category, subcategory })
      });
      const data = await response.json();
      showSuccess(data.message);
      onDiscountApplied();
    } catch (error) {
      console.error(error);
      showError('Error removiendo descuento');
    }
  };

  const selectedCat = categories.find(c => c.name === category);

  return (
    <div className="bulkdisc-panel">
      <div className="bulkdisc-grid">
        {/* Discount Input */}
        <div className="bulkdisc-card">
          <div className="bulkdisc-card-icon" style={{ background: 'rgba(239,68,68,0.1)', color: '#ef4444' }}>
            <i className="fas fa-percent"></i>
          </div>
          <label>Descuento (%)</label>
          <input
            type="number"
            value={discount}
            onChange={(e) => setDiscount(e.target.value)}
            placeholder="Ej: 20"
            min="0"
            max="100"
          />
        </div>

        {/* Category Select */}
        <div className="bulkdisc-card">
          <div className="bulkdisc-card-icon" style={{ background: 'rgba(59,130,246,0.1)', color: '#3b82f6' }}>
            <i className="fas fa-tags"></i>
          </div>
          <label>Categoría</label>
          <select
            value={category}
            onChange={(e) => {
              setCategory(e.target.value);
              setSubcategory('');
            }}
          >
            <option value="">Todas las categorías</option>
            {categories.map((cat) => (
              <option key={cat._id} value={cat.name}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        {/* Subcategory Select */}
        <div className="bulkdisc-card">
          <div className="bulkdisc-card-icon" style={{ background: 'rgba(16,185,129,0.1)', color: '#10b981' }}>
            <i className="fas fa-sitemap"></i>
          </div>
          <label>Subcategoría</label>
          <select
            value={subcategory}
            onChange={(e) => setSubcategory(e.target.value)}
            disabled={!selectedCat?.subcategories?.length}
          >
            <option value="">Todas las subcategorías</option>
            {selectedCat?.subcategories?.map((sub) => (
              <option key={sub.name} value={sub.name}>
                {sub.name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Actions */}
      <div className="bulkdisc-actions">
        <button className="bulkdisc-apply-btn" onClick={handleBulkDiscount}>
          <i className="fas fa-tag"></i>
          Aplicar Descuento
        </button>
        <button className="bulkdisc-remove-btn" onClick={handleRemoveDiscount}>
          <i className="fas fa-eraser"></i>
          Remover Descuento
        </button>
      </div>
    </div>
  );
};

export default BulkDiscount;
